import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Caportal from "./pages/caportal";
import Dashboard from "./pages/Dashboard";
// import LederBoard from "./pages/LeaderBoard";
import Auth from "./pages/Components/auth.js";

// NOTE: Lenis (smooth-scroll library) was removed. It was breaking
// trackpad scrolling — mouse wheel and scrollbar-drag worked fine, but
// trackpad two-finger scroll fires wheel events at a much higher frequency
// than a mouse, and Lenis's tween/interpolation handling of that stream
// wasn't reliable even after tuning its config. Nothing else in the app
// depends on Lenis: the parallax effects (ParallaxBackground, Navbar2)
// use framer-motion's useScroll, which reads native scroll directly and
// needs no smooth-scroll library at all. If a "smooth scroll" feel is
// wanted back, the simplest safe option is CSS: `html { scroll-behavior:
// smooth; }` (only affects anchor-link jumps, not manual wheel/trackpad
// scrolling, so it can't reintroduce this bug).

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Home />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* <Route path="/dashboard/leaderboard" element={<LederBoard />} /> */}
        {/* <Route path="/login" element={<Caportal />} /> */}
        {/* <Route path="/register" element={<Auth />} /> */}
      </Routes>
        {/* <div className="h-0 w-full">
        <Caportal />

      </div> */}
      
      
    </>
  );
}

export default App;